enum TimeRangeEnum {
  ALL = "all",
  WEEK = "week",
  MONTH = "month",
  URGENT = "urgent",
}

export { TimeRangeEnum };
